<template>
<v-dialog
    v-model="dialog"
    fullscreen
    persistent
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Contact RedChirp Support</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickDiscardChanges"
                >
                    Cancel
                </v-btn>

                <v-btn
                    dark
                    text
                    @click="onClickContactSupport"
                >
                    Send
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text>

            <h2
                style="margin-top: 15px; margin-bottom: 15px"
            >
                 <v-icon
                    size="35"
                >
                    mdi-lifebuoy
                </v-icon>

                Get Help With RedChirp
            </h2>

            <p><b>We are here to help!</b></p>
            <p>Tell us a little more about your issue and how you would like us to reach you and we will be in touch shortly</p>

            <v-row>
                <v-col>
                    <v-text-field
                        label="First Name"
                        v-model="first_name"
                        autocomplete="off"
                    />
                </v-col>

                 <v-col>
                    <v-text-field
                        label="Last Name"
                        v-model="last_name"
                        autocomplete="off"
                    />
                </v-col>
            </v-row>

            <v-text-field
                        label="Company Name"
                        v-model="organization_label"
                        autocomplete="off"
                    />

            <v-select
                label="Phone Number"
                :items="phone_numbers"
                v-model="selected_phone_number"
                 v-if="selected_phone_number != 'other'"
            />

            <v-text-field
                label="Enter phone number"
                v-if="selected_phone_number == 'other'"
                v-model="other_phone_number"
            />

            <v-textarea
                label="What do you need help with?"
                rows="3"
                auto-grow
                v-model="message"
            />

            {{consent_specimen}}
            
            <v-checkbox
                label="I Agree"
                v-model="i_agree"
            />

            <v-alert
                :value="show_alert"
                color="primary"
                type="error"
            >
                {{alert_text}}
            </v-alert>

            
            <div
                style="text-align: right"
            >
                <v-btn
                    color="primary"
                    v-on:click="onClickContactSupport"
                >
                    Contact Support
                </v-btn>
            </div>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>

const E164 = require('@/js/E164.js');

export default {

    data() {
        return {
            dialog: false,

            page_name: null,
            first_name: null,
            last_name: null,
            phone_numbers: [],

            organization_label: null,

            selected_phone_number: null,
            other_phone_number: null,
            i_agree: false,
            last_dialog_guard: null,

            alert_text: null,
            show_alert: false,

            message: null,

            consent_specimen: 'By checking the "I agree" check box below, submitting this form, you give RedChirp permission to send text messages with info, promotions and offers to the number you provided. Please note, we may use automation to send these texts. Consent is not a condition of purchase. Texts and calls may be recorded. Message and/or data rates may apply.',
        }
    },

    created () {
        this.$event_bus.$on('support_dialog', this.showDialog);
    },

    beforeDestroy () {
        this.$event_bus.$off('support_dialog',this.showDialog);
    },

    methods: {

        showDialog(params)
        {
            this.page_name = params.page_name;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/support/get-profile',
            
                'params' : {
                    },
            
                'on_success': (data) => {
                        this.dialog = true;
                        this.last_dialog_guard = this.$router.dialog_guard;
                        this.$router.dialog_guard = this.dialogGuard;

                        this.first_name = data.first_name;
                        this.last_name = data.last_name;
                        this.organization_label = data.organization_label;

                        this.phone_numbers = data.phone_numbers;

                        this.phone_numbers.push(
                            {
                                'text': 'Other...',
                                'value': 'other'
                            }
                        );

                        this.selected_phone_number = this.phone_numbers[0].value;
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = this.last_dialog_guard;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
        
            this.closeDialog();
            next(false);
            return;
        },

        onClickDiscardChanges()
        {
            this.closeDialog();
        },

        onClickContactSupport()
        {
            if ( this.i_agree == false ) 
            {
                return this.showAlert('You must agree to receive text messages by checking the "I agree" check box');
            }

            let endpoint = E164.createEndpointFromUSPhoneNumber(this.selected_phone_number, null);
            if ( endpoint == null ) endpoint = E164.createEndpointFromUSPhoneNumber(this.other_phone_number, null);

            if ( endpoint == null )
            {
                return this.showAlert('You need to enter a valid phone number so we have a way to contact you.');
            }

            let organization_id = '8a732595-6621-4d6d-af37-0819110ae721'; // Red Rock Realty
            let inbox_id = '8ae6cf02-f08e-4a2e-a735-91c626bf0d20'; // Mock RedChirp Support Inbox

            if ( this.$rc.inProduction() )
            {
                organization_id = '53485c43-8d64-4be9-82fa-6ae2b4efe575'; // RedChirp
                inbox_id = 'ab0b899a-970e-4127-ac1c-73b8ce7f4466'; // Support inbox
            }

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'POST:  /api/v1/contact-requests/form-connect/:organization_id/:inbox_id',
            
                'params' : {
                        'production': true,
                        'first_name': this.first_name,
                        'last_name': this.last_name,
                        'mobile': endpoint,
                        
                        'consent_specimen': this.consent_specimen+" [x] I Agree",
                        'consent_conversational': true,
                        'consent_informational': true,
                        'consent_promotional': true,

                        'organization_id': organization_id,
                        'inbox_id': inbox_id,
                        'message': this.message,
                        'submitted_from_url': ''+window.location,

                        extra_fields: [
                            { 'text': 'Page Name', 'value': this.page_name },
                            { 'text': 'Organization Label', 'value': this.organization_label },
                        ],
                    },
            
                'on_success': (data) => {
                        this.$rc.alert('Message sent', "Your message has been sent to RedChirp support.<br/><br/>We will be in touch with as soon as possible.");

                        this.closeDialog();
                    },
            
                'on_error': 'Unable to contact support.',
            });
        },

        showAlert(text)
        {
            this.show_alert = true;
            this.alert_text = text;
            return this;
        }
    },



    
}
</script>

<style lang="scss" scoped>

</style>